import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WaitlistActionsComponent } from './waitlist-actions.component';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2Module } from 'angulartics2';
import { FrontendIconsModule } from '@tablesready/frontend-icons';

@NgModule({
  declarations: [WaitlistActionsComponent],
  imports: [CommonModule, NgbTooltipModule, FrontendIconsModule, Angulartics2Module, NgbDropdownModule],
  exports: [WaitlistActionsComponent],
})
export class WaitlistActionsModule {}
